// src/services/authInvalidEvent.js

export const AUTH_INVALID_EVENT = "if:auth-invalid";

export const AUTH_INVALID_REASONS = Object.freeze({
  SESSION_EXPIRED: "SESSION_EXPIRED",
  CSRF_FAILED: "CSRF_FAILED",
  CSRF_MISSING: "CSRF_MISSING",
  TOKEN_EXPIRED: "TOKEN_EXPIRED",
  UNAUTHORIZED: "UNAUTHORIZED",
  MEMBERSHIP_CHANGED: "MEMBERSHIP_CHANGED",
});

const AUTH_ROUTE_PATHS = new Set([
  "/login",
  "/signin",
  "/sign-in",
  "/signup",
  "/register",
  "/forgot-password",
  "/reset-password",
  "/auth/callback",
]);

function isAuthRoutePathname(pathname) {
  const clean = String(pathname || "/").trim() || "/";

  if (AUTH_ROUTE_PATHS.has(clean)) {
    return true;
  }

  return clean.startsWith("/auth/");
}

export function currentReturnTo(fallback = "/") {
  if (typeof window === "undefined") {
    return fallback;
  }

  const pathname = window.location.pathname || "/";

  /**
   * Never use auth pages as returnTo targets.
   * This prevents ugly loops like:
   * /login?returnTo=/login
   */
  if (isAuthRoutePathname(pathname)) {
    return fallback;
  }

  const path = `${pathname}${window.location.search || ""}${
    window.location.hash || ""
  }`;

  return path || fallback;
}

export function emitAuthInvalid(
  reason = AUTH_INVALID_REASONS.SESSION_EXPIRED,
  extra = {}
) {
  if (typeof window === "undefined") {
    return;
  }

  window.dispatchEvent(
    new CustomEvent(AUTH_INVALID_EVENT, {
      detail: {
        reason,
        returnTo: extra.returnTo || currentReturnTo(),
        source: extra.source || "api",
        status: extra.status,
        code: extra.code,
      },
    })
  );
}

export function isAuthInvalidStatus(status) {
  return status === 401 || status === 419;
}

export function isCookieCsrfFailure({
  status,
  isMutating,
  sendCredentials,
  authMode,
}) {
  return (
    status === 403 &&
    Boolean(isMutating) &&
    Boolean(sendCredentials) &&
    String(authMode || "").toLowerCase() === "cookie"
  );
}
